<div class="col-xl-12">
  <div class="col-xl-12">
    <div class="kt-modal3__container">
      <h1 mat-dialog-title class="text-center">{{ titulo }}</h1>
      <mat-dialog-content>
        <p [innerHTML]="texto" class="text-center"></p>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button
          mat-raised-button
          color="warn"
          mat-dialog-close
          *ngIf="cancelButton"
          (click)="onNoClick()"
        >
          {{ textoButtonCancelar }}
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
